import { startLoader, type LoaderScript } from './loaderBootstrap';

(function bootstrap() {
  function currentScript(): LoaderScript | null {
    return document.currentScript as LoaderScript | null;
  }

  startLoader(currentScript());
})();

declare global {
  interface Window {
    QformFitting?: {
      init: (config: {
        apiBaseUrl: string;
        integrationCode?: string;
        runtimeBase?: string;
      }) => void;
      open: (launch: unknown) => Promise<void>;
      close: () => void;
      bindTriggers: (integrationCode?: string) => void;
    };
  }
}

export {};
